import type { PropsWithChildren } from "react";

import OnboardingErrorContent from "../OnboardingErrorContent/OnboardingErrorContent";

import { StyledOnboardingModalContentWrapper } from "./styles";

interface IProps {
    isError?: boolean;
}

const OnboardingModalContent = ({ isError, children }: PropsWithChildren<IProps>) => {
    if (isError) {
        return (
            <StyledOnboardingModalContentWrapper>
                <OnboardingErrorContent />
            </StyledOnboardingModalContentWrapper>
        );
    }

    return <StyledOnboardingModalContentWrapper>{children}</StyledOnboardingModalContentWrapper>;
};

export default OnboardingModalContent;
